(() => {
  if (window.VRAccessoryTest) return;
  const node = document.querySelector('[data-vr-accessory-test-config]');
  if (!node) return;
  const config = JSON.parse(node.textContent);
  const params = new URLSearchParams(location.search);
  const key = 'vr_accessory_test:' + config.id;
  const qaKey = key + ':qa';
  const maxAge = 60 * 24 * 60 * 60 * 1000;
  const variants = ['A', 'B'];
  const root = document.documentElement;
  let assignment = null;
  let consent = false;
  let exposed = false;
  let exposureAttempts = 0;
  let prepared = '';
  let preparing = null;
  let preparingController = null;
  let ready = false;
  let qaVariant = '';
  const preview = Boolean(config.designMode || params.has('preview_theme_id') ||
    (window.Shopify?.theme?.role && window.Shopify.theme.role !== 'main'));
  try {
    if (params.get('vr_accessory_qa') === 'off') sessionStorage.removeItem(qaKey);
    const requested = String(params.get('vr_accessory_variant') || '').toUpperCase();
    if (variants.includes(requested)) sessionStorage.setItem(qaKey, requested);
    qaVariant = sessionStorage.getItem(qaKey) || '';
  } catch (_) {
    qaVariant = String(params.get('vr_accessory_variant') || '').toUpperCase();
  }
  const qa = preview || params.get('vr_qa') === '1' || variants.includes(qaVariant);
  const productEligible = () => Boolean(config.productEligible && document.querySelector('vr-console-accessories[data-count]'));
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    return Boolean(privacy?.analyticsProcessingAllowed?.() && privacy?.saleOfDataAllowed?.());
  };
  const valid = data => data && data.id === config.id && variants.includes(data.variant) &&
    Number.isFinite(data.assignedAt) && Date.now() >= data.assignedAt && Date.now() - data.assignedAt < maxAge;
  const publish = (name, detail = {}) => {
    if (qa || !consent || !assignment || !allowed()) return false;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return false;
    const payload = {
      experiment_id: config.id, experiment_name: config.name, experiment_variant: assignment.variant,
      experiment_mode: 'split', qa: false, product_id: String(config.productId || ''),
      product_handle: config.productHandle || '', page_path: location.pathname, ...detail
    };
    try {
      const result = window.Shopify?.analytics?.publish?.('vitarenew:experiment_' + name, payload);
      result?.catch?.(() => {});
      document.dispatchEvent(new CustomEvent('vr-accessory-test:event', { detail: { name, ...payload } }));
      return true;
    } catch (_) { return false; }
  };
  const apply = () => {
    root.dataset.vrAccessoryAb = assignment?.variant || 'A';
    root.dataset.vrAccessoryProductTest = String(productEligible());
    root.dataset.vrAccessoryTestMode = qa ? 'qa' : assignment ? 'split' : 'unassigned';
    document.dispatchEvent(new CustomEvent('vr-accessory-test:change', { detail: { variant: api.variant, qa } }));
  };
  const enroll = () => {
    if (!ready) return;
    if (qa) {
      assignment = { id: config.id, variant: variants.includes(qaVariant) ? qaVariant : 'B', assignedAt: Date.now() };
      apply();
      return;
    }
    consent = allowed();
    if (!consent) {
      const hadAssignment = Boolean(assignment);
      assignment = null;
      prepared = '';
      preparingController?.abort();
      apply();
      if (hadAssignment) {
        try { localStorage.removeItem(key); } catch (_) {}
        fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
          body: JSON.stringify({ attributes: { vr_experiment__: '' } })
        }).catch(() => {});
      }
      return;
    }
    try {
      const stored = JSON.parse(localStorage.getItem(key) || 'null');
      assignment = valid(stored) ? stored : null;
    } catch (_) {}
    if (!assignment && productEligible()) {
      const random = new Uint32Array(1);
      crypto.getRandomValues(random);
      assignment = { id: config.id, variant: variants[random[0] % 2], assignedAt: Date.now() };
      try { localStorage.setItem(key, JSON.stringify(assignment)); }
      catch (_) { assignment = null; }
    }
    apply();
    if (assignment && productEligible() && !exposed) {
      exposed = publish('exposure', { exposure_surface: 'eligible_product_page' });
      if (!exposed && ++exposureAttempts < 10) setTimeout(enroll, 500);
      // Prepare attribution before accelerated checkout without delaying rendering.
      api.prepareCart();
    }
  };
  const api = window.VRAccessoryTest = {
    config, qa,
    get variant() { return assignment?.variant || 'A'; },
    isTreatment() { return this.variant === 'B' && productEligible(); },
    track: publish,
    async prepareCart() {
      if (qa || !assignment || !consent || !allowed()) return false;
      const value = config.id + ':' + assignment.variant;
      if (prepared === value) return true;
      if (preparing) return preparing;
      const controller = new AbortController();
      preparingController = controller;
      const timeout = setTimeout(() => controller.abort(), 2000);
      preparing = fetch((window.Shopify?.routes?.root || '/') + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, credentials: 'same-origin',
        signal: controller.signal, body: JSON.stringify({ attributes: { vr_experiment__: value } })
      }).then(response => {
        if (!response.ok) return false;
        prepared = value;
        return true;
      }).catch(() => false).finally(() => { clearTimeout(timeout); preparing = null; preparingController = null; });
      return preparing;
    }
  };
  const start = () => {
    ready = true;
    enroll();
    if (!qa && !window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) enroll(); });
    }
  };
  document.addEventListener('visitorConsentCollected', enroll);
  window.addEventListener('storage', event => { if (event.key === key) enroll(); });
  document.addEventListener('submit', event => {
    if (!event.target.matches('form[action$="/cart"]') || event.target.dataset.vrAbSubmitting === 'true') return;
    if (event.submitter?.name !== 'checkout' || qa || !assignment || !consent) return;
    event.preventDefault();
    const form = event.target, submitter = event.submitter;
    api.prepareCart().finally(() => {
      form.dataset.vrAbSubmitting = 'true';
      try { form.requestSubmit(submitter); } finally { delete form.dataset.vrAbSubmitting; }
    });
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
